
import { Navigate } from "react-router-dom";
import { handleCheckUserLogin } from "../../MIS/Global";

const PrivateRoute = ({ children }) => {
  const isLogin = handleCheckUserLogin("userData", "id");

  return isLogin > 0 ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
